import React, { Fragment, useEffect, useState } from 'react';
import { Row, Col, Card } from "reactstrap";
import { useDispatch, useSelector } from 'react-redux';
import { getAllAdmin } from 'Services/Features/Admin/Utils/adminUtils';
import CustomLoader from 'Component/Common/CustomLoader';
import FindAdmin from './Filter/FindAdmin';
import AdminTable from './AdminTable';

const AdminContain = () => {
    const dispatch = useDispatch();
    const admins = useSelector((state) => state.admin.admins);
    const loading = useSelector((state) => state.admin.loading);
    const error = useSelector((state) => state.admin.error);
    const [refetch, setRefetch] = useState(false);
    const filters = useSelector(state => state.admin.filters);

    useEffect(() => {
        dispatch(getAllAdmin(filters));
        window.scrollTo(0, 0);
    }, [dispatch, refetch]);

    if (error) {
        return <div>Error: {error}</div>;
    }

    return (
        <Fragment>
            <Col md="12" className="project-list">
                <Card className="px-3">
                    <FindAdmin />
                </Card>
            </Col>
            <Col xl="12" className="xl-80">
                <Row>
                    {loading ? (
                        <CustomLoader />
                    ) : loading === false && admins.length === 0 ? (
                        <Col md="12">
                            <div className="no-data-found d-flex flex-column align-items-center justify-content-center" style={{ height: '300px' }}>
                                <i className="fa fa-search" style={{ fontSize: '100px', color: '#ccc', marginBottom: '20px' }}></i>
                                <h5 style={{ fontSize: '24px' }}>Admin Tidak Ditemukan</h5>
                            </div>
                        </Col>
                    ) : (
                        <AdminTable setRefetch={setRefetch} />
                    )}
                </Row>
                </Col>
        </Fragment>
    );
};

export default AdminContain;